var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretSortDown = function SvgCaretSortDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.267,
    fillRule: "evenodd",
    d: "M5.26 5.794a.48.48 0 1 0 .68.679L8 4.413l2.06 2.06a.48.48 0 1 0 .68-.68l-2.4-2.4a.48.48 0 0 0-.68 0z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    fillRule: "evenodd",
    d: "M10.74 10.206a.48.48 0 0 0-.68-.679L8 11.587l-2.06-2.06a.48.48 0 0 0-.68.68l2.4 2.4a.48.48 0 0 0 .68 0z",
    clipRule: "evenodd"
  })));
};
export default SvgCaretSortDown;